const initializeArticleList = () => {

    const list = document.querySelector(`.articleList > ul`);
    const loadMoreBtn = document.querySelector(".articleList__loadMore > a");
    let isotope = {};
    const positionRectangleBanners = ( offset = 0 ) => {
        if(list.dataset.containsBanners){
            let listitems = list.querySelectorAll(".articleListItem__article");
            let rectangle = list.querySelector(".articleList__rectangle").cloneNode(true);
            rectangle.removeAttribute('style');
            let repeatRectangles = list.dataset.repeatRectangles;
            let bannerInterval = parseInt(list.dataset.rectangleBannerInterval,10);
            offset = (bannerInterval+1 > offset) ? bannerInterval+1 : offset;

            if(repeatRectangles === "true" || repeatRectangles === "1") {
                for(let i = offset;i < listitems.length;i++){
                    if(i % bannerInterval === 0){
                        if(listitems[i+1] !== null){
                            list.insertBefore(rectangle, listitems[i+1]);
                        }
                    }
                }
            }
        }
    };

    const initializeIsotope = () => {
        isotope = new Isotope(list, {
            itemSelector: '.articleListItem',
            percentPosition: true,
            masonry: {
                columnWidth: '.grid-sizer',
                horizontalOrder: true
            }
        });
        imagesLoaded( list, () => { isotope.layout() });
        window.addEventListener("resize", () => { isotope.layout() });
    };
    
    const setArticleSequenceCookie = () => {
        var lang = document.querySelector('html').getAttribute('lang').split('-')[0];
        document.cookie = `articleSequence_${lang}=${list.dataset.articlesequence};path=/`;
    };

    const initializeLazyLoading = () => {

        loadMoreBtn.addEventListener("click", function(event) {

            event.preventDefault();
            loadMoreBtn.classList.add("isLoading");
            loadMoreBtn.disabled = true;

            fetch(this.dataset.link)
                .then(function (response) {
                    return response.text();
                })
                .then(function (html) {

                    // Parse html to dom, select the nodes needed
                    html = new DOMParser().parseFromString(html, 'text/html');
                    let newArticles = html.querySelectorAll('.articleList > ul > .articleListItem__article');
                    let newBtn = html.querySelector('.articleList__loadMore > a');

                    // Append the new children
                    newArticles.forEach(function(article){
                        list.appendChild(article);
                        isotope.appended(article);
                    });

                    // positionRectangleBanners(list.childElementCount - newArticles.length); @todo banner repetition

                    setTimeout(function() {
                        isotope.layout();
                    },  1000);

                    // Override ajax urls if needed, remove btn if there is no next page
                    if(newBtn){
                        loadMoreBtn.dataset.link = newBtn.dataset.link;
                        loadMoreBtn.href = newBtn.href;
                        loadMoreBtn.classList.remove("isLoading");
                        loadMoreBtn.blur();
                        loadMoreBtn.disabled = false;
                    } else {
                        loadMoreBtn.parentNode.removeChild(loadMoreBtn);
                    }
                })
                .catch(function (err) {
                    loadMoreBtn.classList.remove("isLoading");
                    loadMoreBtn.disabled = false;
                    console.warn('Something went wrong.', err);
                });
        });
    };

    if(list){
        setArticleSequenceCookie();
        initializeIsotope();
        if(list.dataset.containsBanners){
            // positionRectangleBanners(); @todo banner repetition
            // isotope.layout();
        }
        if(loadMoreBtn) initializeLazyLoading();
    }
};

initializeArticleList();